import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import HubDetailsBox from '../../_internal/HubDetailsBox';
import { DataSyncRightIcon } from 'foundations-assets/icons/components/DataSyncRightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Diagram to illustrate the flow of portable assets from a source to a destination account.
 * The default illustration for both source and destination is a sprocket icon.
 * Some illustration props (name, height, and width) can be passed to override the default graphic for either source or destination.
 * Label can be passed to source and destination to override the default title for each account graphic. Default is "Source" and "Destination".
 * @param source - The source account details: optional name, id, label, and illustration props
 * @param destination - The destination account details: optional name, id, label, and illustration props
 * @param marginBlockStart - Optional prop to style the container margin block start
 * @param marginBlockEnd - Optional prop to style the container margin block end
 * @param marginBlock - Optional props to style the container margins.
 * @param maxInlineSize - Optional prop to style the container max inline size.
 * @param `data-test-id` - The optional data-test-id string for testing
 */
function SourceToDestinationDiagram({
  source,
  destination,
  marginBlockStart,
  marginBlockEnd,
  marginBlock,
  maxInlineSize,
  ['data-test-id']: dataTestId
}) {
  if (!(source !== null && source !== void 0 && source.name) || !(source !== null && source !== void 0 && source.id) || !(destination !== null && destination !== void 0 && destination.name) || !(destination !== null && destination !== void 0 && destination.id)) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    overflow: "auto",
    marginBlockStart: marginBlockStart,
    marginBlockEnd: marginBlockEnd,
    marginBlock: marginBlock,
    maxInlineSize: maxInlineSize,
    "data-test-id": dataTestId,
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(HubDetailsBox, Object.assign({}, source, {
        label: (source === null || source === void 0 ? void 0 : source.label) || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "portability.source"
        })
      }))
    }), /*#__PURE__*/_jsx(View, {
      marginInline: "300",
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx(DataSyncRightIcon, {
        size: "800",
        color: "icon-core-default"
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(HubDetailsBox, Object.assign({}, destination, {
        label: (destination === null || destination === void 0 ? void 0 : destination.label) || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "portability.destination"
        })
      }))
    })]
  });
}
export default SourceToDestinationDiagram;